export default {
  path: '/register',
  meta: {
    title: '注册',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/register`),
}



// WEBPACK FOOTER //
// ./src/views/register/router.js